import { useEffect, useRef, useState } from "react";

/**
 * Smoothly animate a numeric value from a starting point to `target`.
 * Uses requestAnimationFrame + ease-out for a satisfying ticker feel.
 */
export default function useCountUp(target = 0, { duration = 1400, decimals = 0 } = {}) {
  const [val, setVal] = useState(0);
  const fromRef = useRef(0);
  const startRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    fromRef.current = val;
    startRef.current = null;
    cancelAnimationFrame(rafRef.current);
    const step = (ts) => {
      if (startRef.current == null) startRef.current = ts;
      const p = Math.min(1, (ts - startRef.current) / duration);
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      const next = fromRef.current + (target - fromRef.current) * eased;
      setVal(decimals === 0 ? Math.round(next) : parseFloat(next.toFixed(decimals)));
      if (p < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, duration, decimals]);

  return val;
}
